// https://github.com/xmaestro/angular2-recaptcha
// https://github.com/xmaestro/angular2-recaptcha/issues/7

import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  NgZone
} from '@angular/core';
import { environment } from './../../environments/environment';
import { DOCUMENT } from '@angular/platform-browser';
import { LocaleService } from './seo/locale.service'

declare var grecaptcha: any;
import * as Raven from 'raven-js';

@Component({
  selector: 'app-re-captcha',
  template: '<div class="g-recaptcha" [attr.data-sitekey]="siteKey" data-callback="reCaptchaVerifyCallback" [attr.data-size]="size"></div>'
})
/*Captcha functionality component*/
export class ReCaptchaComponent implements OnInit {

  @Input()
  siteKey: string = environment.re_captcha_site_key;

  @Input()
  version: string = environment.re_captcha_version ? environment.re_captcha_version : 'v2_normal';

  @Output()
  captchaResponse: EventEmitter<string>;

  get size(): string {
    return this.version.replace('v2_', '');
  }

  constructor(
    private zone: NgZone,
    private localeService: LocaleService,
    @Inject(DOCUMENT) private document: any,
    @Inject('WINDOW') private window: any
  ) {
    if (this.window)
      this.window['reCaptchaVerifyCallback'] = (response: any) => this.zone.run(this.recaptchaCallback.bind(this, response));
    this.captchaResponse = new EventEmitter<string>();
  }

  recaptchaCallback(response: any): void {
    Raven.captureBreadcrumb({
      message: 'ReCaptcha reCaptchaVerifyCallback',
      category: 'ReCaptcha'
    });
    this.captchaResponse.emit(response);
  }

  ngOnInit(): void {
    Raven.captureBreadcrumb({
      message: 'ReCaptcha init',
      category: 'ReCaptcha',
      data: {
        re_captcha_version: this.version
      }
    });

    const doc = this.document.body as HTMLDivElement;
    const script = this.document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://www.google.com/recaptcha/api.js?hl=' + this.localeService.getCurrentLocale();
    script.async = true;
    script.defer = true;
    doc.appendChild(script);
  }

  reset(): void {
    Raven.captureBreadcrumb({
      message: 'ReCaptcha reset',
      category: 'ReCaptcha'
    });
    grecaptcha.reset();
  }

  execute(): void {
    Raven.captureBreadcrumb({
      message: 'ReCaptcha execute',
      category: 'ReCaptcha'
    });
    grecaptcha.execute();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/re-captcha.component.ts